import { useState } from "react";
import { Ruler } from "lucide-react";
import { SIZE_GUIDES } from "../../lib/sizeGuides";

const fmt = (inches, unit) => (unit === "in" ? `${inches}"` : `${Math.round(inches * 2.54 * 10) / 10} cm`);

export const SizeGuide = ({ guideKey }) => {
  const [open, setOpen] = useState(false);
  const [unit, setUnit] = useState("in");
  const guide = SIZE_GUIDES[guideKey];
  if (!guide) return null;

  return (
    <div className="mb-5" data-testid="size-guide">
      <button type="button" onClick={() => setOpen(!open)} data-testid="size-guide-toggle"
        className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-[#4B3A2F] underline underline-offset-4 hover:text-[#D62839] transition-colors duration-300">
        <Ruler size={14} /> {open ? "Hide size guide" : "Size guide"}
      </button>
      {open && (
        <div className="mt-3 rounded border border-[#E7DFD5] bg-white p-4" data-testid="size-guide-panel">
          <div className="flex items-center justify-between mb-2">
            <p className="font-display text-base text-[#4B3A2F]">{guide.name}</p>
            <div className="flex rounded-full border border-[#D9CBB8] overflow-hidden text-[11px]">
              {["in", "cm"].map((u) => (
                <button key={u} type="button" onClick={() => setUnit(u)} data-testid={`size-guide-unit-${u}`}
                  className={`px-3 py-1 ${unit === u ? "bg-[#4B3A2F] text-[#F9F6F0]" : "text-[#4B3A2F]"}`}>{u}</button>
              ))}
            </div>
          </div>
          <table className="w-full text-sm text-[#2C2724]" data-testid="size-guide-table">
            <thead>
              <tr className="text-left text-[10px] uppercase tracking-[0.2em] text-[#8D7B6E]">
                <th className="py-1">Size</th><th>Length</th><th>Width</th>
              </tr>
            </thead>
            <tbody>
              {guide.rows.map(([size, length, width]) => (
                <tr key={size} className="border-t border-[#EFE6D8]" data-testid={`size-guide-row-${size}`}>
                  <td className="py-1 font-semibold">{size}</td><td>{fmt(length, unit)}</td><td>{fmt(width, unit)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="text-[11px] text-[#6D5A50] mt-2 leading-snug">{guide.note}</p>
        </div>
      )}
    </div>
  );
};
